import { queryAction } from '../actions/query'
import { queryMutation } from '../mutations/query'

export const query = {
  state: {
    'query/car': {
      data: {}
    },
    'query/person': {
      data: {}
    },
    'query/person/status': {
      data: {}
    },
    'query/zmxy': {
      data: {}
    },
    'query/maintain': {
			data: {}
		},
		'query/illegal': {
			data: {}
		},
		'query/insurance': {
			data: {}
    },
    'query/house': {
			data: {}
    },
    'query/lawsuit': {
			data: {}
		}
  },
  mutations: queryMutation,
  actions: queryAction
}



// WEBPACK FOOTER //
// ./src/store/modules/query.js